/** Reads `?code=XXXXXX` from the current location, per SPEC.md §5 share
 * link. Trims + uppercases to match server normalizeRoomCode. */
export function codeFromLocation(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) return null;
    const trimmed = code.trim().toUpperCase();
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
}

export function shareLinkFor(code: string): string {
  const url = new URL(window.location.href);
  url.search = '';
  url.hash = '';
  url.searchParams.set('code', code);
  return url.toString();
}
